import { render, staticRenderFns } from "./join.vue?vue&type=template&id=c7680b0c&scoped=true&"
import script from "./join.js?vue&type=script&lang=js&"
export * from "./join.js?vue&type=script&lang=js&"
import style1 from "./join.vue?vue&type=style&index=1&id=c7680b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7680b0c",
  null
  
)

export default component.exports